import { DXL_BRANDING, SCHRIFT_FAMILIE, luminanz, type Branding } from '@dxl/shared';

// Kontrastprüfung liegt in @dxl/shared, damit der Server dieselben Regeln anwendet
export { brandingPruefen, kontrast, kontrastPaare, luminanz, type KontrastBefund } from '@dxl/shared';

export function mischen(a: string, b: string, anteil: number): string {
  const x = parseInt(a.slice(1), 16);
  const y = parseInt(b.slice(1), 16);
  const k = (v: number, w: number) => Math.round(v + (w - v) * anteil);
  const r = k((x >> 16) & 255, (y >> 16) & 255);
  const g = k((x >> 8) & 255, (y >> 8) & 255);
  const bl = k(x & 255, y & 255);
  return '#' + ((1 << 24) | (r << 16) | (g << 8) | bl).toString(16).slice(1).toUpperCase();
}

/** Branding → CSS-Variablen. Alles Weitere in styles.css leitet sich hiervon ab. */
export function brandingZuCss(b: Branding = DXL_BRANDING): Record<string, string> {
  const f = b.farben;
  const dunkel = b.erscheinungsbild === 'dunkel';
  const helleNav = luminanz(f.navigation) > 0.4;
  return {
    '--dxl-haupt': f.haupt,
    '--dxl-akzent': f.akzent,
    '--dxl-akzent-flaeche': mischen(f.flaeche, f.akzent, dunkel ? 0.22 : 0.1),
    '--dxl-button': f.button,
    '--dxl-button-text': f.buttonText,
    '--dxl-button-hover': mischen(f.button, dunkel ? '#FFFFFF' : '#000000', 0.12),
    '--dxl-hintergrund': f.hintergrund,
    '--dxl-flaeche': f.flaeche,
    '--dxl-flaeche-2': mischen(f.flaeche, f.text, 0.04),
    '--dxl-nav': f.navigation,
    '--dxl-nav-text': f.navigationText,
    // Aktiver Menüpunkt: auf heller Navigation eine Fläche, auf dunkler ein aufgehellter Ton
    '--dxl-nav-aktiv': helleNav ? f.flaeche : mischen(f.navigation, '#FFFFFF', 0.09),
    '--dxl-nav-text-stark': helleNav ? f.text : '#FFFFFF',
    '--dxl-nav-linie': helleNav ? f.linie : mischen(f.navigation, '#FFFFFF', 0.1),
    '--dxl-text': f.text,
    '--dxl-text-2': f.textGedaempft,
    '--dxl-linie': f.linie,
    '--dxl-ecken': `${b.ecken}px`,
    '--dxl-ecken-klein': `${Math.max(2, Math.round(b.ecken / 2))}px`,
    '--dxl-schrift': `'${SCHRIFT_FAMILIE[b.schrift] ?? SCHRIFT_FAMILIE.Montserrat}', system-ui, sans-serif`,
    // Statusfarben: auf dunklen Flächen hellere Töne, sonst nicht lesbar
    '--dxl-gut': dunkel ? '#5FD3A6' : '#18794E',
    '--dxl-schlecht': dunkel ? '#FF8A96' : '#C2273A',
    '--dxl-warnung': dunkel ? '#F2B65A' : '#A15C07',
    'color-scheme': dunkel ? 'dark' : 'light',
  };
}

export function brandingAnwenden(b: Branding = DXL_BRANDING, ziel: HTMLElement = document.documentElement): void {
  for (const [k, v] of Object.entries(brandingZuCss(b))) ziel.style.setProperty(k, v);
}
